import React from 'react';
import { useSelector } from 'react-redux';

// Components
import SelectButton from './SelectButton';

const buildOptions = (areas, areasKey, selectedValue, selectedLabel, fallbackLabel) => {
	const baseOptions = areasKey in areas ? areas[areasKey] : [fallbackLabel];

	if (!selectedValue || !Array.isArray(baseOptions)) return baseOptions;

	const alreadyIncluded = baseOptions.some(opt => opt?._id?.$oid === selectedValue);
	if (alreadyIncluded) return baseOptions;

	return [...baseOptions, { _id: { $oid: selectedValue }, name: selectedLabel || '' }];
};

const AreaFilters = ({
	areaFilters,
	areaLabels = { region: '', zone: '', depot: '', group: '' },
	onChangeAreaFilters,
	areas,
	disableInputs,
	areasLoading,
	hideGroup = false,
	hiddenLevels = { region: false, zone: false, depot: false, group: false }
}) => {
	const { global_data } = useSelector(state => state.global);

	const hideRegion = hiddenLevels.region;
	const hideZone = hiddenLevels.zone;
	const hideDepot = hiddenLevels.depot;
	const hideGroupLevel = hideGroup || hiddenLevels.group;

	if (hideRegion && hideZone && hideDepot && hideGroupLevel) return null;

	return (
		<div className='d-flex row align-items-center justify-content-center mb-4'>
			<div className='text-center mb-2'>
				<i className='bi bi-globe2 me-2'></i>{global_data?.organizationTerms?.areas}
			</div>
			{!hideRegion && (
				<SelectButton
					label={global_data?.organizationTerms?.region}
					options={buildOptions(areas, 'regions', areaFilters.region, areaLabels.region, 'No regions')}
					name='region'
					value={areaFilters.region === '' ? null : areaFilters.region}
					onChange={onChangeAreaFilters}
					disable={disableInputs}
					orgFilter={false}
					loading={areasLoading}
				/>
			)}
			{!hideZone && (
				<SelectButton
					label={global_data?.organizationTerms?.zone}
					options={buildOptions(areas, 'zones', areaFilters.zone, areaLabels.zone, 'No zones')}
					name='zone'
					value={areaFilters.zone === '' ? null : areaFilters.zone}
					onChange={onChangeAreaFilters}
					disable={disableInputs}
					orgFilter={false}
					loading={areasLoading}
				/>
			)}
			{!hideDepot && (
				<SelectButton
					label={global_data?.organizationTerms?.depot}
					options={buildOptions(areas, 'depots', areaFilters.depot, areaLabels.depot, 'No depots')}
					name='depot'
					value={areaFilters.depot === '' ? null : areaFilters.depot}
					onChange={onChangeAreaFilters}
					disable={disableInputs}
					orgFilter={false}
					loading={areasLoading}
				/>
			)}
			{!hideGroupLevel && (
				<SelectButton
					label={global_data?.organizationTerms?.group}
					options={buildOptions(areas, 'groups', areaFilters.group, areaLabels.group, 'No groups')}
					name='group'
					value={areaFilters.group === '' ? null : areaFilters.group}
					onChange={onChangeAreaFilters}
					disable={disableInputs}
					orgFilter={false}
					loading={areasLoading}
				/>
			)}
		</div>
	);
}

export default AreaFilters;
